module.exports = __webpack_public_path__ + "static/media/mg.e285f0ce.svg";